import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';
import { PANEL_WIDTH } from './const';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: PANEL_WIDTH,
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch',
      backgroundColor: COLORS.neutral.white,
      border: `1px solid ${COLORS.neutral.lightGray}`,
      borderRadius: theme.shape.borderRadius,
      boxShadow: '0px 0px 18px rgba(0, 0, 0, 0.15)',
    },
    content: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch',
      padding: theme.spacing(2),
    },
    header: {
      display: 'flex',
      flexFlow: 'row nowrap',
    },
    texts: {
      display: 'flex',
      flexFlow: 'column nowrap',
      marginLeft: theme.spacing(1.25),
      overflow: 'hidden',
    },
    avatar: {
      fontSize: theme.typography.pxToRem(39),
    },
    title: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightMedium,
      color: COLORS.neutral.secondary,
    },

    description: {
      marginTop: theme.spacing(0.5),

      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(12),
      color: COLORS.neutral.mediumGray,
    },
    pains: {
      marginTop: theme.spacing(1.25),
    },
    actions: {
      display: 'flex',
      flexFlow: 'row wrap',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(1.25),
    },
    button: {
      padding: 2.5,
      borderRadius: theme.shape.borderRadiusSmall,
      height: 21,
      width: 21,

      '&:hover': {
        color: COLORS.primary.default,
        backgroundColor: COLORS.primary.light,
      },
      '& + &': {
        marginLeft: theme.spacing(1),
      },
      '& svg': {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    iconEditPersona: {
      fontSize: theme.typography.pxToRem(12),
    },

    customActions: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      padding: theme.spacing(1, 2),
      borderTop: `1px solid ${COLORS.gray.gray80}`,
    },
  }),
  { name: 'PersonaDetailsPanel' }
);
